import { createSlice } from '@reduxjs/toolkit';
import { getPhoneAuthToken, setPhoneAuthToken, clearPhoneAuthToken, getUserPhone, setUserPhone } from '../../services/auth';

const initialState = {
  token: getPhoneAuthToken() || null,
  phone: getUserPhone() || '',
  isLoggedIn: !!getPhoneAuthToken(),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      const { token, phone } = action.payload || {};
      if (token) setPhoneAuthToken(token);
      if (phone) setUserPhone(phone);
      state.token = token || null;
      state.phone = phone || '';
      state.isLoggedIn = !!token;
    },
    logout: (state) => {
      clearPhoneAuthToken();
      state.token = null;
      state.phone = '';
      state.isLoggedIn = false;
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;
